import { Pipe, PipeTransform } from '@angular/core';
import { CMS_END_POINTS } from '../const/api';
import { ConfigService } from '../services/config.service';

@Pipe({
  name: 'imageSource'
})
export class ImageSourcePipe implements PipeTransform {

  constructor(private configService: ConfigService){}

  transform(imageFile: string = ''): string {
    if (!imageFile) return '';

    if (imageFile.startsWith('assets/images/')) return imageFile;
    if (imageFile.startsWith('assets/svgs/')) return imageFile;

    // Check if the route is an external URL
    if (
      imageFile.startsWith('//') ||
      imageFile.startsWith('http://') ||
      imageFile.startsWith('https://') ||
      imageFile.startsWith('www.')
    ) {
      return imageFile;
    } else if (imageFile === 'loadingImage2') {
      return 'assets/images/default-img-2.gif'
    } else if (imageFile === 'loadingImage') {
      return 'assets/images/Qjet_5.gif'
    } else if (imageFile === 'errorImage') {
      return 'assets/images/default-qjet.jpg'
    } else {
      if(imageFile === '00000000-0000-0000-0000-000000000000') return 'assets/images/default-qjet.jpg'
      return imageFile ? this.configService.baseURL + CMS_END_POINTS.GET_IMAGE_BY_FILE + "?id=" + imageFile : 'assets/images/default-img.webp';
    }
  }

}
